/* /tdb/ingredient-master · Roji's rate editor + Dipali's approval queue */
import { useEffect, useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import TDBIngredientMaster from '@/components/TDBIngredientMaster';

export default function TDBIngredientMasterPage() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get('/auth/me');
        setUser(r.data?.user || r.data);
      } catch (e) {
        navigate('/login');
      }
    })();
  }, [navigate]);

  return (
    <div data-testid="tdb-ingredient-master-page" className="min-h-screen bg-slate-50">
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center gap-3">
          <button
            data-testid="tdb-im-back-btn"
            onClick={() => navigate('/division/tdb')}
            className="text-slate-600 hover:text-slate-900 flex items-center gap-1 text-sm"
          >
            <ChevronLeft className="w-4 h-4" /> Back to TDB
          </button>
          <div className="h-6 w-px bg-slate-200" />
          <h1 className="text-base font-semibold text-slate-900">Ingredient Master</h1>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-6">
        {user && <TDBIngredientMaster currentUser={user} />}
      </div>
    </div>
  );
}
